import React, { useState } from 'react';
import CenteredRow from '../../CenteredRow';
import Input from '../../Input';
import Button from '../../Button';
import Flexor from '../../Flexor';
import { Container } from './styled';

function NameInput({
  submit, firstName: _firstName, lastName: _lastName, email: _email,
}) {
  const [firstName, setFirstName] = useState(_firstName);
  const [lastName, setLastName] = useState(_lastName);
  const [email, setEmail] = useState(_email);
  return (
    <Container as="form" onSubmit={() => submit({
      firstName,
      lastName,
      email,
    })}>
      <CenteredRow style={{ width: '100%', marginBottom: 20 }}>
        {!_firstName && <Input
          data-cy="dwolla-first-name"
          id="firstname"
          required
          value={firstName}
          update={setFirstName}
          label="First Name"
          style={{ marginRight: 20 }}
        />}
        {!_lastName && <Input
          data-cy="dwolla-last-name"
          value={lastName}
          id="lastname"
          required
          update={setLastName}
          label="Last Name"
        />}
      </CenteredRow>
      {!_email && < Input
        data-cy="dwolla-email"
        value={email}
        id="email"
        required
        update={setEmail}
        label="Email" />}
      <Flexor flex="0 0 20px" />
      <Button submit label="Next" />
    </Container>
  );
}

export default NameInput;
